<template>
  <div>
    <v-toolbar dense color="white">
      <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
    </v-toolbar>
    <v-form ref="form">
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <v-row>
          <v-col cols="5">
            <v-text-field
              :value="parseDisasterName"
              label="災害名称"
              placeholder=" "
              readonly
            >
            </v-text-field>
          </v-col>
          <v-col cols="6" sm="3" md="3" lg="2">
            <v-text-field
              :value="emergencyStatusName"
              label="緊急事態区分"
              placeholder=" "
              readonly
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="3" md="3" lg="3">
            <v-textarea
              :value="parsedDeliveryArea"
              label="配信先エリア"
              placeholder=" "
              readonly
              rows="3"
            >
            </v-textarea>
          </v-col>
          <v-col cols="6" sm="3" md="3" lg="3">
            <v-text-field
              :value="parsedDeliveryLevel"
              label="配信レベル"
              placeholder=" "
              readonly
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="submitItem.selectedLanguage"
              label="翻訳言語"
              placeholder=" "
              readonly
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-tabs v-model="selectedTab" color="black">
          <v-tab
            v-for="tab in translatelanguages"
            :key="tab.no"
            @change="changeTab(tab)"
          >
            {{ tab.name }}
          </v-tab>
          <v-tab-item v-for="tab in translatelanguages" :key="tab.no">
            <v-card class="v-tab-item">
              <v-row v-show="showTranslationCheck">
                <v-col cols="6" lg="2">
                  <v-checkbox
                    v-if="!laterCheckLabelFlag[tab.no]"
                    v-model="submitItem.checkTranslation[tab.no]"
                    label="後から翻訳する"
                    disabled
                  >
                  </v-checkbox>
                  <v-text-field
                    v-else
                    v-model="checkTranslationVal"
                    placeholder=" "
                    disabled
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="8">
                  <v-text-field
                    v-model="submitItem.deliveryTitle[tab.no]"
                    label="件名"
                    placeholder=" "
                    readonly
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row v-show="showAppCheck">
                <v-col col="6">
                  <v-checkbox
                    class="mycheckbox lowCheckBox mx-2"
                    v-model="submitItem.isPostLine"
                    label="【LINE】鹿児島県原子力防災公式アカウントへ送信"
                    disabled
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row v-show="showAppCheck">
                <v-col col="6">
                  <v-checkbox
                    class="lowCheckBox mx-12"
                    v-model="submitItem.isConfirmHavingIodine"
                    label="安定ヨウ素剤所持を確認"
                    disabled
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
              <v-row v-show="showAppCheck">
                <v-col col="6">
                  <v-checkbox
                    class="lowCheckBox mx-2"
                    v-model="submitItem.isPostTwitter"
                    label="【Twitter】鹿児島県原子力防災公式アカウントへ送信"
                    disabled
                  >
                  </v-checkbox>
                  <p style="padding-left:450px;">
                    ※144文字超える場合は、文字切れして配信します。
                  </p>
                </v-col>
              </v-row>
              <v-row>
                <!-- attaching files -->
                <v-col cols="2">
                  <div class="d-flex">
                    <v-btn
                      @click="selectUploadFile"
                      class="mx-2 mt-3"
                      color="primary"
                    >
                      ファイル参照
                    </v-btn>
                  </div>
                  <v-dialog v-model="fileUploadDialog">
                    <v-card>
                      <v-card-title></v-card-title>
                      <v-card-text>
                        <v-toolbar dense color="white">
                          <v-toolbar-title>ファイル参照</v-toolbar-title>
                        </v-toolbar>
                        <v-data-table
                          v-model="selectedFileItems"
                          :headers="filesHeaders"
                          :items="editedFileItems"
                          class="elevation-1 mt-2"
                          locale="ja-jp"
                          item-key="imageNo"
                          hide-default-footer
                          no-data-text="データはありません。"
                        >
                          <template v-slot:[`item.file`]="{ item }">
                            <v-file-input
                              v-model="item.file"
                              :placeholder="config.PLACEHOLDER_FILE"
                              :accept="config.FILE_INPUT_ACCEPT"
                              prepend-icon="mdi-paperclip"
                              class="mt-2"
                              dense
                              v-bind="formControlProps()"
                              disabled
                            >
                              <template v-slot:selection="{ text }">
                                <v-chip small label color="primary">
                                  {{ text }}
                                </v-chip>
                              </template>
                            </v-file-input>
                          </template>
                          <template v-slot:[`item.imageTitle`]="{ item }">
                            <v-text-field
                              v-model="item.imageTitle"
                              :placeholder="config.PLACEHOLDER_INPUT"
                              class="mt-2"
                              dense
                              v-bind="formControlProps(30)"
                              disabled
                            >
                            </v-text-field>
                          </template>
                        </v-data-table>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          class="mx-2"
                          color="primary"
                          @click="fileUploadDialog = false"
                        >
                          戻る
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="8">
                  <v-textarea
                    v-model="submitItem.deliveryBody[tab.no]"
                    counter="1000"
                    maxlength="1000"
                    label="通知文(スマホアプリ(プッシュ通知))"
                    :placeholder="' '"
                    readonly
                  >
                  </v-textarea>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-container>
    </v-form>
    <template>
      <v-btn
        class="mx-2"
        color="primary"
        v-if="hasEditAuth()"
        @click="onClickDuplicate"
      >
        コピーして編集
      </v-btn>
      <v-btn class="mx-2" color="primary" @click="onClickReturn">戻る</v-btn>
    </template>
    <v-overlay :value="overlay" opacity="1" color="white" z-index="2">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import cloneDeep from "lodash/cloneDeep";
import config from "@/js/const";
import { EmergencyClass } from "@/js/value-objects/emergency-class";
import { DisasterClass } from "@/js/value-objects/disaster-class";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import Disaster from "@/plugins/disaster";
import { ScreenId } from "@/js/value-objects/screen-id";
import { ScreenCrud } from "@/js/value-objects/screen-crud";
import messageUtils from "@/mixins/message-utils";
import { arrayCount, makeRandom } from "@/js/utils";
Vue.use(Disaster);

const disasterDeliveryDetailRepository = RepositoryFactory.get(
  "disasterDeliveryDetail"
);

const DEFAULT_FILES = [
  {
    imageNo: -1, // ファイル連番（マイナスの場合は新規登録）
    imageTitle: "", // タイトル
    imageFileName: "", // イメージファイル名
    url: "",
    s3object: makeRandom(6),
    file: null, // ファイルオブジェクト
    fileUploadFlag: true // true：ファイルアップロードを実施
  }
];
const DEFAULT_LATER_FLAG = [false, false, false, false, false];
const TRANSLATION_STATUS_NON = "0"; //未翻訳
const TRANSLATION_STATUS_DONE = "1"; //翻訳済
const DELIVERY_STATUS_NON = "0"; //未配信
const LOCALE_EN = "en";
const LOCALE_KO = "ko";
const LOCALE_ZH_TW = "zh-TW";
const LOCALE_ZH_CN = "zh-CN";

export default {
  mixins: [messageUtils],
  components: {
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage")
  },
  props: {
    delivery_no: String
  },
  data: () => ({
    overlay: false,
    screenId: ScreenId.SF0303,
    screenTitle: "",
    selectedFileItems: [],
    fileUploadDialog: false, // ファイル添付ダイアログのv-model
    editedFileItems: [], // ファイルダイアログの編集情報
    config: config, // ファイル拡張子取得用config
    disasterDeliveryDetail: {}, // 災害配信情報（DB取得値）
    disasters: [], // 未終結の災害情報（DB取得値）
    municipalities: [], // 配信先エリア
    submitItem: {
      deliveryNo: "", // 配信番号
      disasterNo: "", // 災害No
      emergCls: EmergencyClass.NL, // 緊急事態区分
      disasterCls: DisasterClass.T, // 災害区分
      deliveryArea: [], // 配信エリア
      deliveryLevel: "", // 配信レベル
      selectedLanguage: [], // 翻訳言語選択
      checkTranslation: [], // 後から翻訳情報
      isPostLine: false, // 鹿児島県公式LINEアカウントへ送信
      isConfirmHavingIodine: false, // 安定ヨウ素剤所持を確認
      isPostTwitter: false, // 鹿児島県公式Twitterアカウントへ送信
      deliveryTitle: [], // 件名
      deliveryBody: [], // 通知文（プッシュ通知）
      deliveryStatus: "", // 配信ステータス
      translationStatusEn: "", //翻訳ステータス(英語)
      translationStatusKo: "", //翻訳ステータス(韓国語)
      translationStatusZhCn: "", //翻訳ステータス(中簡体)
      translationStatusZhTw: "", //翻訳ステータス(中繫体)
      attachFiles: DEFAULT_FILES // 添付ファイル
    },
    deliveryLevels: [
      { delivery_level: "0", level_name: "強制配信" },
      { delivery_level: "1", level_name: "重要配信（レベル1/2設定）" },
      { delivery_level: "2", level_name: "通常配信（レベル2設定）" }
    ],
    showTranslationCheck: false, // 後から翻訳表示フラグ（日本語タブ：非表示、日本語以外：表示）
    showAppCheck: true, // アプリチェック（LINE、Twitter）表示フラグ（日本語タブ：表示、日本語以外：非表示）
    laterCheckLabelFlag: DEFAULT_LATER_FLAG, // 後から翻訳表示切り替えフラグ（ラベル、チェックボックスを切り替える）
    translatelanguages: [
      { no: 0, name: "日本語" },
      { no: 1, name: "英語" },
      { no: 2, name: "韓国語" },
      { no: 3, name: "中国語（簡体）" },
      { no: 4, name: "中国語（繁体）" }
    ],
    selectedTab: null, // 選択しているタブ情報
    checkTranslationVal: "翻訳済み"
  }),

  computed: {
    // ファイルヘッダー
    filesHeaders() {
      return [
        {
          text: "ID",
          align: " d-none",
          value: "imageNo",
          sortable: false
        },
        {
          text: "ファイル",
          value: "file",
          sortable: false
        },
        {
          text: "タイトル",
          value: "imageTitle",
          sortable: false
        }
      ];
    },

    // 災害名称（参照用）
    parseDisasterName() {
      const disasterItem = this.disasters.find(
        obj => obj.disaster_no === this.submitItem.disasterNo
      );
      if (disasterItem) {
        return disasterItem.disaster_name;
      } else {
        return "";
      }
    },

    // 緊急事態区分（参照用）
    emergencyStatusName() {
      return EmergencyClass.factory(this.submitItem.emergCls).toName();
    },

    // 配信先エリア（参照用）
    parsedDeliveryArea() {
      const municipArray = [];
      this.municipalities.forEach(obj => {
        this.submitItem.deliveryArea.forEach(municip => {
          if (obj.value === municip) {
            municipArray.push(obj.text);
          }
        });
      });
      return municipArray;
    },

    // 配信レベル
    parsedDeliveryLevel() {
      const level = this.submitItem.deliveryLevel;
      if (
        typeof level != undefined &&
        this.deliveryLevels[level] != undefined
      ) {
        return this.deliveryLevels[level].level_name;
      } else {
        return "";
      }
    },

    formControlProps: () => {
      return function(counter = null) {
        return this.$formControlProps(false, counter);
      };
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    // 初期化処理
    async initialize() {
      this.overlay = true;
      this.screenTitle = ScreenId.getScreenTitle(this.screenId);
      this.pageTitle(this.screenTitle);
      // 災害情報
      await this.$store
        .dispatch("disasterInfo/loadDisasterInfo", this.screenId)
        .catch(e => {
          this.handleError(e, this.screenId, "evacuation-order-management");
        });
      // 市町村
      await this.$store
        .dispatch("allArea/loadAllArea")
        .then(() => {
          this.municipalities = this.$store.state.allArea.municipalities;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "evacuation-order-management");
        });
      // 災害配信情報
      const deliveryDetails = await disasterDeliveryDetailRepository
        .list(this.screenId, this.delivery_no)
        .catch(e => {
          this.handleError(e, this.screenId, "evacuation-order-management");
        });
      // 災害配信情報
      this.disasterDeliveryDetail = deliveryDetails.data.results[0];
      // 災害情報
      this.disasters = this.$store.state.disasterInfo.data.results;
      this.submitItem.deliveryNo = this.delivery_no;
      // 災害名称テキストボックス
      this.submitItem.emergCls = this.$disaster.emerg_cls;

      // 各制御初期化
      this.laterCheckLabelFlag = cloneDeep(DEFAULT_LATER_FLAG);

      // 災害名称テキストボックス
      this.submitItem.disasterNo = this.disasterDeliveryDetail.disaster_no;
      // 緊急事態区分テキストボックス
      const disasterItem = this.disasters.find(
        obj => obj.disaster_no === this.submitItem.disasterNo
      );
      if (disasterItem) {
        this.submitItem.emergCls = disasterItem.emerg_cls;
      } else {
        this.submitItem.emergCls = EmergencyClass.NL;
      }
      if (arrayCount(this.disasterDeliveryDetail.dests) > 0) {
        this.disasterDeliveryDetail.dests.forEach(dest => {
          this.submitItem.deliveryArea.push(dest.municip_code);
        });
      }
      this.submitItem.deliveryLevel = this.disasterDeliveryDetail.delivery_lev;
      this.submitItem.deliveryTitle[0] = this.disasterDeliveryDetail.delivery_title;
      this.submitItem.deliveryBody[0] = this.disasterDeliveryDetail.delivery_body;

      // LINE、Twitter、安定ヨウ素剤チェック
      this.submitItem.isPostLine =
        this.disasterDeliveryDetail.is_post_line === "1" ? true : false;
      this.submitItem.isConfirmHavingIodine =
        this.disasterDeliveryDetail.is_confirm_having_iodine === "1"
          ? true
          : false;
      this.submitItem.isPostTwitter =
        this.disasterDeliveryDetail.is_post_twitter === "1" ? true : false;

      if (arrayCount(this.disasterDeliveryDetail.translations) > 0) {
        this.disasterDeliveryDetail.translations.forEach(translation => {
          // 英語
          if (translation.locale === LOCALE_EN) {
            this.submitItem.selectedLanguage.push(
              this.translatelanguages.filter(item => item.no === 1)[0].name
            );
            this.submitItem.deliveryTitle[1] = translation.delivery_title;
            this.submitItem.deliveryBody[1] = translation.delivery_body;
          }
          this.submitItem.checkTranslation[1] =
            this.disasterDeliveryDetail.translation_status_en ===
            TRANSLATION_STATUS_NON
              ? true
              : false;
          // 韓国語
          if (translation.locale === LOCALE_KO) {
            this.submitItem.selectedLanguage.push(
              this.translatelanguages.filter(item => item.no === 2)[0].name
            );
            this.submitItem.deliveryTitle[2] = translation.delivery_title;
            this.submitItem.deliveryBody[2] = translation.delivery_body;
          }
          this.submitItem.checkTranslation[2] =
            this.disasterDeliveryDetail.translation_status_ko ===
            TRANSLATION_STATUS_NON
              ? true
              : false;
          // 中国語(簡体)
          if (translation.locale === LOCALE_ZH_CN) {
            this.submitItem.selectedLanguage.push(
              this.translatelanguages.filter(item => item.no === 3)[0].name
            );
            this.submitItem.deliveryTitle[3] = translation.delivery_title;
            this.submitItem.deliveryBody[3] = translation.delivery_body;
          }
          this.submitItem.checkTranslation[3] =
            this.disasterDeliveryDetail.translation_status_zh_cn ===
            TRANSLATION_STATUS_NON
              ? true
              : false;
          // 中国語(繁体)
          if (translation.locale === LOCALE_ZH_TW) {
            this.submitItem.selectedLanguage.push(
              this.translatelanguages.filter(item => item.no === 4)[0].name
            );
            this.submitItem.deliveryTitle[4] = translation.delivery_title;
            this.submitItem.deliveryBody[4] = translation.delivery_body;
          }
          this.submitItem.checkTranslation[4] =
            this.disasterDeliveryDetail.translation_status_zh_tw ===
            TRANSLATION_STATUS_NON
              ? true
              : false;
        });
      }
      // 各ステータス
      this.submitItem.deliveryStatus = this.disasterDeliveryDetail.delivery_status;
      this.submitItem.translationStatusEn = this.disasterDeliveryDetail.translation_status_en;
      this.submitItem.translationStatusKo = this.disasterDeliveryDetail.translation_status_ko;
      this.submitItem.translationStatusZhCn = this.disasterDeliveryDetail.translation_status_zh_cn;
      this.submitItem.translationStatusZhTw = this.disasterDeliveryDetail.translation_status_zh_tw;

      const attachFiles = this.disasterDeliveryDetail.attach_files;
      if (arrayCount(attachFiles) > 0) {
        this.submitItem.attachFiles = attachFiles.map(attachFile => {
          const pushItem = {
            imageNo: attachFile.image_no,
            imageTitle: attachFile.image_title,
            imageFileName: attachFile.image_filename,
            url: "",
            s3object: attachFile.s3object,
            file: new File([""], attachFile.image_filename),
            fileUploadFlag: false
          };
          return pushItem;
        });
      }
      this.switchCheckLabel(); // 後から翻訳のラベル／チェック切り替え
      this.overlay = false;
    },

    // 編集用ファイルアイテムの設定
    selectUploadFile() {
      this.fileUploadDialog = true;
      this.editedFileItems = cloneDeep(this.submitItem.attachFiles);
    },

    // 翻訳ステータス毎のラベル、チェックボックスの表示を切り替える
    // true ：ラベル、false：チェックボックス
    switchCheckLabel() {
      // 配信ステータスが未配信以外（後から翻訳対象の場合）
      if (this.submitItem.deliveryStatus !== DELIVERY_STATUS_NON) {
        // 英語
        if (this.submitItem.translationStatusEn === TRANSLATION_STATUS_DONE) {
          this.laterCheckLabelFlag[1] = true;
        }
        // 韓国語
        if (this.submitItem.translationStatusKo === TRANSLATION_STATUS_DONE) {
          this.laterCheckLabelFlag[2] = true;
        }
        // 中簡体
        if (this.submitItem.translationStatusZhCn === TRANSLATION_STATUS_DONE) {
          this.laterCheckLabelFlag[3] = true;
        }
        // 中繫体
        if (this.submitItem.translationStatusZhTw === TRANSLATION_STATUS_DONE) {
          this.laterCheckLabelFlag[4] = true;
        }
      }
    },

    // 編集画面の権限があるかチェック
    hasEditAuth() {
      const editScreenId = ScreenId.SF0305;
      const editAuth = this.$screenAuthority.find(
        auth => auth.screen_id === editScreenId
      );
      if (editAuth) {
        const screenCrud = ScreenCrud.factory(editAuth.screen_crud);
        return screenCrud.isOperation();
      } else {
        return false;
      }
    },

    // コピーして編集ボタン押下時処理
    onClickDuplicate() {
      this.$router.push({
        name: `push-notification-duplicate`,
        params: {
          delivery_no: this.disasterDeliveryDetail.delivery_no
        }
      });
    },

    // 戻るボタン押下時処理
    onClickReturn() {
      this.$router.push("/evacuation-order");
    },

    // タブ選択時の後から翻訳の表示判定
    changeTab(tab) {
      if (tab.no == 0) {
        this.showTranslationCheck = false;
        this.showAppCheck = true;
      } else {
        this.showTranslationCheck = true;
        this.showAppCheck = false;
      }
    }
  }
};
</script>

<style scoped>
.v-tab-item {
  padding: 10px;
}

.v-tab {
  background-color: #dcdcdc;
  color: black;
}

.lowCheckBox {
  height: 0;
  padding: 3;
  margin: 1;
}
</style>
